<!-- transactions -->
<script>
import Errors from "../shared/components/errors-page/errors.vue";
import Loader from "../shared/components/loader/loader.vue";
import moment from "moment";
import axios from "axios";
export default {
  data() {
    return {
      networkError: false,
      error: false,
      error401: false,
      error500: false,
      errorOther: false,
      search: "",
      isLoading: true,
      sortingObj: {
        limit: 7,
        page: 1,
        sortBy: "created_at",
        sortOrder: "DESC",
        search: ``,
        pin: ''
      },
      reachEndOfScroll: false,
      transactions: [],
      totalTransactions: 0,
    };
  },
  components: {
    Errors,
    Loader,
  },
  watch: {
    reachEndOfScroll: {
      handler() {
        if (
          this.totalTransactions <
          this.sortingObj.page * this.sortingObj.limit
        )
          return;
        this.sortingObj.page += 1;
        this.getTransaction(this.sortingObj);
      },
    },
    search: {
      handler(search) {
        this.sortingObj.page = 1;
        this.sortingObj.search = search;
        this.transactions = [];
        this.getTransaction(this.sortingObj);
      },
    },
  },
  methods: {
    bottomVisible() {
      let elem = document.getElementById("scroller");
      const scrollY = elem.scrollTop;
      const visible = elem.offsetHeight;
      const elemHeight = elem.scrollHeight;
      const bottomOfPage = visible + scrollY >= elemHeight;
      return bottomOfPage || elemHeight < visible;
    },
    scrollHandler() {
      this.reachEndOfScroll = this.bottomVisible();
    },
    trasactionDetail(id) {
      this.$router.push(`/transactions/${id}`);
    },
    backPage() {
      this.$router.push("/profile");
    },
    sortTransactions(sortBy, sortOrder) {
      this.sortingObj.sortBy = sortBy;
      this.sortingObj.sortOrder = sortOrder;
      this.sortingObj.page = 1;
      this.transactions = [];

      this.getTransaction(this.sortingObj);
    },
    getTransaction(data) {
      this.sortingObj.pin = this.$store.state.userData.memberId
      axios
        .post(`${process.env.VUE_APP_API_URL}/Transaction/list`, data, {
          withCredentials: true,
        })
        .then((res) => {
          res.data.items.forEach((element) => {
            element.created_at = moment(element.created_at).format(
              "DD/MM/YYYY"
            );
          });
          this.transactions.push(...res.data.items);
          this.isLoading = false;
          this.totalTransactions = res.data.totalRows;
        })
        .catch((error) => {
          if (error.response.data.error.status === 401) {
            this.error = true;
            this.error401 = true;
          } else if (error.response.data.error.status === 500) {
            this.error = true;
            this.error500 = true;
          } else {
            this.error = true;
            this.errorOther = true;
          }
        });
    },
  },
  created() {
    if (navigator.onLine) {
      this.networkError = false;
      this.error = false;
    } else {
      this.error = true;
      this.networkError = true;
    }
    this.getTransaction(this.sortingObj);
  },
};
</script>

<!-- Template -->
<template>
  <fragment>
    <div v-if="!error" class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-lg-8 col-md-12 col-sm-12 col-xs-12 md-offset-0">
          <!-- Header --Start -->
          <div class="hide-on-mob">
            <div class="header-button-container">
              <div class="col-4 px-0">
                <b-button
                  @click="backPage()"
                  class="back-button btn-ripple"
                  variant="outline-light"
                >
                  <img class="arrow" src="../../assets/arrow.svg" alt />
                  {{ $tc("message.backAndNext", 1) }}
                </b-button>
              </div>
              <div class="col-8 pt-1">
                <h2 class="transaction-title">
                  {{ $tc("message.transactionHeaders") }}
                </h2>
              </div>
            </div>
            <!-- Header --End -->
            <div class="row transaction-main-container bg-light hide-on-mob">
              <div class="container-header-section bg-white">
                <b-col lg="6" md="6" sm="8" xs="12" class="px-0">
                  <div class="select-transaction-title">
                    <h3 class="px-0">
                      {{ $tc("message.transactionHeaders", 2) }}
                    </h3>
                  </div>
                </b-col>
                <b-col lg="6" md="6" sm="4" class="pr-0">
                  <div>
                    <b-form-input
                      class="search-store"
                      v-model="search"
                      :placeholder="$tc('message.searchplaceholder', 2)"
                    ></b-form-input>
                  </div>
                </b-col>
              </div>

              <div class="hide-on-mob container-heading-row bg-white">
                <div class="col-3 border-right">
                  <b-dropdown
                    aria-haspopup="false"
                    variant="btn-white border-white"
                    class="border-white"
                    toggle-class="p-0"
                    no-caret
                    block
                    type="text"
                  >
                    <template #button-content>
                      <span class="col date-section text-left">
                        {{ $tc("message.transactionTableHeaderTitle", 0) }}
                        <img
                          class="vectorimg"
                          src="../../assets/arrow-down.svg"
                          alt
                        />
                      </span>
                    </template>
                    <b-dropdown-item
                      @click="sortTransactions('created_at', 'DESC')"
                      >{{ $tc("message.sortingOptions", 1) }}</b-dropdown-item
                    >
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item
                      @click="sortTransactions('created_at', 'ASC')"
                      >{{ $tc("message.sortingOptions", 0) }}</b-dropdown-item
                    >
                  </b-dropdown>
                </div>
                <div class="col-3 border-right purchase-section">
                  <span
                    >{{ $tc("message.transactionTableHeaderTitle", 1) }}
                  </span>
                </div>
                <div
                  class="col-3 border-right text-right"
                >
                  <b-dropdown
                    aria-haspopup="false"
                    variant="outline-red"
                    toggle-class="p-0"
                    no-caret
                  >
                    <template #button-content>
                      <span class="m-0">
                        {{ $tc("message.transactionTableHeaderTitle", 2) }}
                        <img
                          class="vectorimg"
                          src="../../assets/arrow-down.svg"
                          alt
                        />
                      </span>
                    </template>
                    <b-dropdown-item
                      @click="sortTransactions('total_points', 'ASC')"
                      >{{ $tc("message.sortingMessages", 1) }}</b-dropdown-item
                    >
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item
                      @click="sortTransactions('total_points', 'DESC')"
                      >{{ $tc("message.sortingMessages", 0) }}</b-dropdown-item
                    >
                  </b-dropdown>
                </div>
                <div class="col-3 text-right">
                  <b-dropdown
                    aria-haspopup="false"
                    variant="outline-red"
                    toggle-class="p-0"
                    no-caret
                    right
                  >
                    <template #button-content>
                      <span class="m-0">
                        {{ $t("message.totalCost") }}
                        <img
                          class="vectorimg"
                          src="../../assets/arrow-down.svg"
                          alt
                        />
                      </span>
                    </template>
                    <b-dropdown-item
                      class="dropdown-items"
                      @click="sortTransactions('total', 'ASC')"
                      >{{ $tc("message.sortingMessages", 1) }}</b-dropdown-item
                    >
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item
                      class="dropdown-items"
                      @click="sortTransactions('total', 'DESC')"
                      >{{ $tc("message.sortingMessages", 0) }}</b-dropdown-item
                    >
                  </b-dropdown>
                </div>
              </div>
              <div class="hide-on-mob" v-if="isLoading === false">
                <div
                  class="transaction-container-body bg-white"
                  id="scroller"
                  @scroll="scrollHandler"
                >
                  <div
                    class="container-body-row border-bottom"
                    v-for="transaction in transactions"
                    :key="transaction.id"
                    @click="trasactionDetail(transaction.id)"
                  >
                    <div class="col-3 values-column">
                      <span class="">{{ transaction.created_at }}</span>
                    </div>
                    <div class="col-3 values-column">
                      <span class="text-capitalize">{{
                        transaction.buyer_name
                      }}</span>
                    </div>
                    <div class="col-3 text-right values-column pr-26">
                      <span
                        >{{
                          Number(transaction.total_points).toLocaleString()
                        }}
                        pts</span
                      >
                    </div>
                    <div class="col-3 values-column text-right">
                      <span
                        >${{ transaction.total | formatNumber }}</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- mobile view start -->
          <div class="mobileVisible">
            <div class="row header-button-container">
              <div class="col-4 pr-0">
                <b-button
                  @click="backPage()"
                  class="back-button btn-ripple"
                  variant="outline-light"
                >
                  <img class="arrow" src="../../assets/arrow.svg" alt />
                  {{ $tc("message.backAndNext", 1) }}
                </b-button>
              </div>
              <div class="col-7 pt-1 px-0 text-left">
                <h2 class="transaction-title-mobile">
                  {{ $tc("message.transactionHeaders", 1) }}
                </h2>
              </div>
            </div>
            <div class="container-header-section">
              <div class="col-12 px-0">
                <div class="select-transaction-title pl-11">
                  <h3 class="pl-0">
                    {{ $tc("message.transactionHeaders", 2) }}
                  </h3>
                </div>
              </div>
              <div class="col-10 px-0 pb-2">
                <b-form-input
                  class="search-store-mobile"
                  v-model="search"
                  :placeholder="$tc('message.searchplaceholder', 2)"
                ></b-form-input>
              </div>
            </div>

            <div class="dropdown-container-mobile border border-top-0">
              <div class="dropdown-section-mobile">
                <b-dropdown
                  aria-haspopup="false"
                  variant="outline-red"
                  no-caret
                  toggle-class="p-0"
                >
                  <template #button-content>
                    <span class="dropdown-section-mobile px-0">
                      {{ $tc("message.transactionPointHeaderTitle", 2) }}
                      <img
                        class="vectorimg"
                        src="../../assets/arrow-down.svg"
                        alt
                      />
                    </span>
                  </template>
                  <b-dropdown-item
                    @click="sortTransactions('created_at', 'DESC')"
                    >{{ $tc("message.sortingOptions", 1) }}</b-dropdown-item
                  >
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item
                    @click="sortTransactions('created_at', 'ASC')"
                    >{{ $tc("message.sortingOptions", 0) }}</b-dropdown-item
                  >
                </b-dropdown>
              </div>
              <div class="dropdown-section-mobile text-right">
                <b-dropdown
                  aria-haspopup="false"
                  variant="outline-red"
                  no-caret
                  right
                  toggle-class="p-0"
                >
                  <template #button-content>
                    <span class="dropdown-section-mobile px-0">
                      {{ $tc("message.transactionPointHeaderTitle", 1) }}
                      <img
                        class="vectorimg"
                        src="../../assets/arrow-down.svg"
                        alt
                      />
                    </span>
                  </template>
                  <b-dropdown-item @click="sortTransactions('total', 'ASC')">{{
                    $tc("message.sortingMessages", 1)
                  }}</b-dropdown-item>
                  <b-dropdown-divider></b-dropdown-divider>
                  <b-dropdown-item @click="sortTransactions('total', 'DESC')">{{
                    $tc("message.sortingMessages", 0)
                  }}</b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
            <div
              class="transaction-container-body bg-white"
              v-if="!isLoading"
              id="scroller"
              @scroll="scrollHandler"
            >
              <div
                class="container-body-row-mobile border-bottom"
                v-for="transaction in transactions"
                :key="transaction.id"
                @click="trasactionDetail(transaction.id)"
              >
                <div class="purchase-section-mobile">
                  <span class="values-column-mobile overflow-para">{{ transaction.buyer_name }}</span>
                  <span class="purchase-section-mobile-value subvalues-column pt-1"
                    >{{ $tc("message.transactionTableHeaderTitle", 0) }}:
                    {{ transaction.created_at }}
                  </span>
                </div>
                <div class="points-section-mobile text-right mr-0">
                  <span class="values-column-mobile">
                    ${{ transaction.total | formatNumber }}
                  </span>
                  <span class="points-section-mobile subvalues-column pt-1">
                    {{ Number(transaction.total_points).toLocaleString() }}pts
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- mobile view end -->
      </div>
      <loader v-if="isLoading === true"></loader>
    </div>
    <errors
      v-else
      :errorNetworkrErrorprops="this.networkError"
      :error401props="this.error401"
      :error500props="this.error500"
      :errorOtherprops="this.errorOther"
    ></errors>
  </fragment>
</template>

<!-- Style -->
<style lang="scss" scoped>
.row, .col, .col-3 {
  margin: 0;
  padding: 0;
}
.transaction-main-container {
  display: flex;
  flex-direction: column;
  padding: 50px 50px;
  border: 1px solid #e5e5e5;
}
.container-header-section {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #e5e5e5;
  padding: 10px 24px;
  align-items: center;
}
.container-value-section {
  position: inherit;
  border: none;
  cursor: pointer;
  padding-top: 10px;
  padding-bottom: 10px;
}
.container-body-row-mobile {
  position: relative;
  padding: 8px 24px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.container-body-row {
  position: relative;
  display: flex;
  cursor: pointer;
}

.container-body-row-mobile:last-child {
  border-radius: 0 0 5px 5px;
}

.purchase-section-mobile {
  position: relative;
  display: flex;
  flex-direction: column;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
}
.purchase-section-mobile-value {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
}
.purchase-section {
  display: flex;
  text-align: left;
  align-items: center;
}
.purchase-section-value {
  text-align: left;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #7d8c9b;
}
.sorting-section-value {
  text-align: right;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #7d8c9b;
  align-items: center;
}
.total-purchase-section-mobile {
  position: relative;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
}
.points-section-mobile {
  display: flex;
  flex-direction: column;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 19px;
  text-align: right;
}
.points-section-mobile-value {
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 20px;
}

@media (min-width: 992px) and (max-width: 1200px) {
  .col-lg-8 {
    flex: 0 0 80% !important;
  }
}

.transaction-title {
  font-style: normal;
  font-weight: bold;
  font-size: 32px;
  line-height: 38px;
  margin: 0 auto;
  letter-spacing: 0.1925px;
}
.transaction-title-mobile {
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;
  align-items: center;
  padding-top: 9px;
}
@media (max-width: 1366px) {
  .store-title {
    font-size: 27px;
  }
}
@media (min-width: 600px) and (max-width: 736px) {
  .store-title {
    font-size: 18px;
  }
}
@media (min-width: 701px) and (max-width: 768px) {
  .store-title {
    font-size: 22px;
  }
}
.container-section {
  position: relative;
  border: 1px solid #e5e5e5;
  box-sizing: border-box;
  border-radius: 5px 5px 0 0;
}
.search-store {
  float: right;
  max-width: 329px;
  border-radius: 5px;
  background: #ffffff;
  background-blend-mode: multiply;
  border: 1px solid #c1c8cf;
  background-image: url("../../assets/search.svg");
  background-position: 12px 12px;
  background-repeat: no-repeat;
  padding: 12px 20px 12px 40px;
  margin-top: 5px;
}
.search-store-mobile {
  border-radius: 5px;
  background: #ffffff;
  background-blend-mode: multiply;
  border: 1px solid #c1c8cf;
  background-image: url("../../assets/search.svg");
  background-position: 12px 12px;
  background-repeat: no-repeat;
  padding: 12px 20px 12px 40px;
  margin-top: 5px;
}
.select-transaction-title h3 {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #45505B;
  margin-bottom: 0px;
  padding: 15px 9px;
}
.container-heading-row {
  display: flex;
  flex-wrap: wrap;
}
.container-heading-row .purchase-section span,
.container-heading-row .sorting-section-2 span,
.container-heading-row .date-section span,
.container-heading-row .sorting-section span,
.b-dropdown button {
  font-style: normal;
  font-weight: 500;
  font-size: 14px !important;
  color: #7d8c9b !important;
}

.sorting-section {
  text-align: right;
  align-items: center;
}
@media (max-width: 768px) {
  .container-heading-row .purchase-section {
    font-size: 13px !important;
  }
}
.transaction-container-body {
  border: 1px solid #e5e5e5;
  border-top: none;
  box-sizing: border-box;
  border-radius: 0 0 5px 5px;
  overflow-y: scroll;
  scroll-behavior: smooth;
  max-height: 330px;
}
.header-button-container {
  display: flex;
  padding: 15px 0px;
}
.back-button {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
}
.container,
.container-fluid,
.container-sm {
  padding-right: 0px;
  padding-left: 0px;
}
.dropdown-container-mobile {
  display: flex;
  justify-content: space-between;
}
.dropdown-section-mobile {
  position: relative;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #687888;
}

.vectorimg {
  justify-content: right;
}

.btn:active,
.btn:focus,
.btn.active {
  outline: none;
  -webkit-box-shadow: none;
  box-shadow: none;
}
.purchase-section {
  padding: 0 24px;
}
.b-dropdown, .values-column {
  width: 100%;
  padding: 14px 24px;
}
.values-column, .values-column-mobile {
  font-size: 14px;
  font-weight: 400;
  color: #45505B;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.subvalues-column {
  font-size: 12px;
  font-weight: 400;
  color: #7D8C9B;
}
.b-dropdown .btn {
  padding: 0 !important;
}
.b-dropdown .btn span {
  display: flex;
  font-weight: 500 !important;
  font-size: 14px;
  justify-content: flex-end;
  color: #7D8C9B;
}
.b-dropdown .btn span img {
  margin-left: 10px;
}
.date-section {
    justify-content: space-between !important;
}
.dropdown-item, .dropdown-menu li a, .dropdown-menu {
  color: #4E4E4E !important;
  font-size: 14px !important;
  font-weight: 500;
}
.overflow-para {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 157px;
}
@media (max-width: 380px) {
  .dropdown-section-mobile {
    margin: 0px;
  }
  .b-dropdown{
    padding: 14px 0 14px 12px;
  }
  .purchase-section-mobile {
    margin: 0px;
  }
}
</style>